import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Funnel, CaretDown, CaretUp, X, ArrowCounterClockwise, Check } from '@phosphor-icons/react';

export const FilterPanel = ({ children, onApply, onReset, activeCount = 0 }) => {
  const [open, setOpen] = useState(false);

  return (
    <div data-testid="filter-panel">
      <div className="flex items-center gap-2">
        <Button variant={open ? 'default' : 'outline'} size="sm" onClick={() => setOpen(!open)}
          className={`gap-1.5 ${open ? 'bg-emerald-600 hover:bg-emerald-700' : ''}`} data-testid="filter-toggle-btn">
          <Funnel size={14} weight="bold" />
          Filter Results
          {activeCount > 0 && <Badge className="ml-1 bg-white/20 text-white text-[10px] px-1.5">{activeCount}</Badge>}
          {open ? <CaretUp size={12} /> : <CaretDown size={12} />}
        </Button>
      </div>

      {open && (
        <Card className="mt-3 border-slate-200 bg-slate-50/80" data-testid="filter-body">
          <CardContent className="p-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-bold text-slate-800 font-['Outfit']">Filter By</h3>
              {activeCount > 0 && <Badge variant="secondary" className="text-[10px]">{activeCount} active</Badge>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {children}
            </div>
            <div className="flex gap-2 mt-5 pt-4 border-t border-slate-200">
              <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 gap-1" onClick={() => { onApply?.(); setOpen(false); }} data-testid="filter-apply-btn">
                <Check size={14} weight="bold" /> Apply
              </Button>
              <Button variant="secondary" size="sm" className="gap-1" onClick={() => { onReset?.(); }} data-testid="filter-reset-btn">
                <ArrowCounterClockwise size={14} weight="bold" /> Reset
              </Button>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export const FilterField = ({ label, children }) => (
  <div className="space-y-1">
    <label className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider">{label}</label>
    {children}
  </div>
);
